<div class="dialog-component" >
    <div class="cross">
      <button
        id="photo-edit-close"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click)="dialogData.reset()"
      ></button>
    </div>
  
    <div class="image-container">
      <div class="profile-photo-header">
        <button
          id="photo-edit-close-mobile"
          tabindex="0"
          type="button"
          class="close close-btn"         
          aria-label="Close"
          (click)="dialogData.reset()"
        ></button>
        <button class="save-button" (click)="dialogData.crop()">Save</button> 
     </div>

     
<!-- start browse photo section-->
     <div id="profile-browse-panel">
   
     <div class="orientation browse-block">
        <img alt="browse" src="assets/account-management/images/icons/browse-photo.svg" />
        <input type="file" value="Browse for photo" id="upload-profile-photo" class="browser-file"
            (change)="dialogData.changeSrcFile($event)"/>
        <label class="browse-button" for="upload-profile-photo" >Browse for photo</label>
    </div>
   
    <div class="image-display">
        <div class="cropme-container" style="width: 500px; height: 400px;">

            <div class="viewport circle"
                style="width: 150px; height: 150px; border-width: 2px; border-color: rgb(255, 255, 255);">
                <img alt="photo" src="data:image/png;base64,{{dialogData.imageResponse.FileData}}" style="opacity:1"></div>
        </div>
        <div class="btn-container cropper-controll image-display-contianer">
            <button class="browse-button" (click)="dialogData.deletePic()">Delete</button>
            <input type="file" value="Browse for photo" id="upload-profile-photo" class="browser-file"
                (change)="dialogData.changeSrcFile($event)">
            <label class="browse-button" for="upload-profile-photo">Browse for photo</label>
            <button class="delete-button" (click)="dialogData.deletePic()">Delete</button>
        </div>
    </div>

</div>
<!-- end browse photo section -->

    
<!-- start edit photo section-->
<div id="profile-editpic-panel" style="display:none">
    
         <div class="orientation">
            <div id="div1" (drop)="dialogData.drop($event)" (dragover)="dialogData.allowDrop($event)">
                <img alt="my-image" id="my-image" />
            </div>
           <div class="photo-edit-info">For best results, please use a good quality image and crop your photo so that only one person appears</div>
            <div class="cropme-wrapper cropper-tools">
                <div class="cropme-slider">
                    <div class="slider-info">
                        <span>ZOOM</span>
                        <span id="zoom-value" style="display:none"></span>
                    </div>
                    <input type="range" min="0.05" max="1.5" step="0.01" class="slider" id="zoom-slider"
                        (change)="dialogData.onZoom($event)">
                        <div class="zoom-custom"></div>
                    <div class="slider-highlight" id="zoom-highlight"></div>
                </div>
                <div class="cropme-rotation-slider">
                    <div class="slider-info">
                        <span>ROTATE</span>
                        <span id="rotate-value">0&deg; </span>
                    </div>
                    <input type="range" min="-90" max="90" step="10" class="slider" id="rotation-slider"
                        (change)="dialogData.onRotate($event)">
                        <div class="rotate-custom"></div> 
                    <div class="slider-highlight" id="rotate-highlight" style="width:50%"></div>
                    <div class="rotate-icon" (click)="dialogData.rotate90()"></div>
                </div>

            </div>
            <div class="btn-container cropper-controll">
                <input type="file" value="Browse for photo" id="again-upload-profile-photo"
                    class="browser-file" (change)="dialogData.changeSrcFile($event)">
                <label class="browse-button" for="again-upload-profile-photo">Browse for photo</label>
                <button class="save-button" (click)="dialogData.crop()">Save</button>
            </div>
        </div>

    </div>
    <!-- end edit photo section -->

    
    <div tabindex="-1" id="warning-popup" style="display:none" class="overlay">
        <div class="warning-popup">
            <div class="warning-icon"></div>
            <label tabindex="0" role="alert" aria-label="dialog" class="warning-text" id="warning-text" style="text-align: left;">
                Sorry, the maximum file size you can upload is
                10MB</label>
            <button class="save-button error-btn" aria-label="ok" (click)="dialogData.closeWarning()">OK</button>
        </div>
    </div>

    
        </div>
        </div>
    